<div class="card">
	<div class="card-header">
		<h1>Planillas</h1>
	</div>
	<div class="card-body">
		<p class="text-muted">Selecciona las opciones de cálculo de pago</p>
		<div class="row">
			<div class="col-sm form-group">
				<label for="contract" class="form-label">Por contrato</label>
				<select name="contract" (change)="getNumberEmployees()" [(ngModel)]="newPayroll.paymentPeriod" id="contract" class="form-select">
					<option value="0">Diario</option>
					<option value="1">Semanal</option>
					<option value="2">Catorcenal</option>
					<option value="3">Quincenal</option>
					<option value="4">Mensual</option>
				</select>
				<p class="form-text"><i tooltip="Personal contratado" class="fa fa-user"></i>{{numberOfEmployees}}</p>
			</div>
			<div class="col-sm form-group">
				<label for="month" class="form-label">Mes</label>
				<input type="month" name="month" id="month" [(ngModel)]="month" class="form-control">
			</div>
			<div class="col-sm form-group">
				<label for="startDate" class="form-label">Fecha Inicio</label>
				<input type="date" [(ngModel)]="newPayroll.date" name="startDate" id="startDate" class="form-control">
			</div>
			<div class="col-sm form-group">
				<label for="endDate" class="form-label">Fecha Final</label>
				<input type="date" [(ngModel)]="newPayroll.endDate" name="endDate" id="endDate" class="form-control">
			</div>
		</div>
	</div>
	<div class="card-footer">
		<button class="btn btn-success" (click)="getSummary()" [disabled]="generating || !month || 
			!newPayroll.date || !newPayroll.endDate || numberOfEmployees == 0">
			<i class="fa fa-hammer" *ngIf="!generating"></i>
			<span *ngIf="generating" class="spinner-border spinner-border-sm"></span>
			GENERAR
		</button>
	</div>
</div>
<div class="card mt-1" *ngIf="summary">
	<div class="card-header">
		<h1>Resumen de pagos</h1>
	</div>
	<div class="body">
		<div class="table-responsive">
			<table class="table table-bordered">
				<thead>
					<tr>
						<th>POSICIÓN</th>
						<th class="td-center">EMPLEADOS</th>
						<th class="td-center">ACEPTADOS</th>
						<th class="td-center">TOTAL</th>
					</tr>
				</thead>
				<tbody>
					<ng-container *ngFor="let position of summary">
						<tr>
							<td>
								<i (click)="dropDown[position.positionId] = !dropDown[position.positionId]"
									[tooltip]="dropDown[position.positionId]?'Ocultar desglose':'Ver desglose'"
									[ngClass]="dropDown[position.positionId]?'fa fa-angle-up':'fa fa-angle-down'"></i>{{position.positionName}}
							</td>
							<td class="td-center">{{position.personal.length}}</td>
							<td class="td-center">
								<!-- <i
									[ngClass]="position.accepted?'text-success fa fa-check':'text-danger fa fa-xmark'"></i> -->
								{{getAccepted(position)}}
							</td>
							<td class="td-center">{{ position.total | currency:'Q'}}</td>
						</tr>
						<tr *ngIf="dropDown[position.positionId]">
							<td colspan="4" style="padding: 1em;">
								<table class="table" [class.no-accepted]="!employee.accepted"
									*ngFor="let employee of position.personal">
									<thead>
										<tr class="table-active">
											<th><i (click)="employee.accepted = !employee.accepted; getAcceptedTotal(position)"
													[ngClass]="employee.accepted?'fa fa-toggle-on':'fa fa-toggle-off'"></i>{{employee.employeeName}}
											</th>
											<th class="td-center">Total {{employee.total | currency:'Q'}}</th>
										</tr>
										<tr>
											<th>dfas</th>
											<th class="td-center">CANTIDAD</th>
										</tr>
									</thead>
									<tbody>
										<tr *ngFor="let payment of employee.payments">
											<td>
												{{payment.description}}
											</td>
											<td class="td-center">
												{{payment.amount | currency:'Q'}}
											</td>
										</tr>
									</tbody>
								</table>
							</td>
						</tr>
					</ng-container>
				</tbody>
				<tfoot>
					<tr>
						<td colspan="3">
							Total
						</td>
						<td class="td-center">
							{{totalAll | currency: 'Q'}}
						</td>
					</tr>
				</tfoot>
			</table>
		</div>
	</div>
	<div class="card-footer">
		<button class="btn btn-success" (click)="saveGeneratedPayroll()" [disabled]="!summary">
			<i class="fa fa-save" *ngIf="!saving"></i>
			<span *ngIf="saving" class="spinner-border spinner-border-sm"></span>
			GUARDAR
		</button>
	</div>
</div>